<template>
  <bs-modal
    ref="bsModal"
    :name="`update-acceptance-${issueid}`"
    :ok-title="$t('javascript.yes_update_secret')"
    :cancel-title="$t('javascript.cancel')"
    @ok="$emit('ok', {endSession, allowMediatorToSeeSecret})"
    @cancel="$emit('cancel')"

    :disable-ok="true"
    :disable-cancel="true"
    :is-open="value"
    :value="value"
    @input="$emit('input', $event)"
  >
    <form class="form-inline">
      
      <!-- Modal button moved here to replace the span -->
      <div class="row">
        <div class="col-sm-6 text-start">
          <button type="button" class="btn btn-primary" @click="handleOkClick">
            {{ $t('javascript.update_my_secret') }}
          </button>

        </div>
        <div class="col-sm-3" style="margin-top:10px;">
          <span v-html="$t('javascript.from_last_position', {lastPosition})"></span>
        </div>
        <div class="form-group col-sm-3">
          <!-- Removed span -->
          <select
            :value="acceptance"
            @input="$emit('update:acceptance', getAcceptance($event))"
            class="form-control form-inline"
          >
            <option v-for="point in gridPoints">
              {{ point }}
            </option>
          </select>
        </div>
      </div>
      <p></p>
      <p></p>

      <!-- Cancel button moved to the left of the form-check div -->
      
      <div class="d-flex justify-content-between align-items-center">
        <button type="button" class="btn btn-secondary" @click="handleCancelClick" style="margin-right: 15px;">
          {{ $t('javascript.cancel') }}
        </button>

        
        <label>
          <input
            v-model="endSession"
            class="form-check-input"
            style="margin-top:10px;"
            type="checkbox"
          >
          &nbsp; {{ otherPartyEndedOrDoneSession ? $t('javascript.check_for_agreement_now') : $t('javascript.i_m_done_session', {sessionNumber}) }}
        </label>
        <label v-if="askForMediatorPerms">  <!-- Ask only if mediator is not allowed to see it yet -->
          <input
            v-model="allowMediatorToSeeSecret"
            class="form-check-input"
            type="checkbox"
          >
          &nbsp; {{ $t('javascript.allow_mediator_to_see') }}
        </label>
        
      </div>
      <p></p>
    </form>
  </bs-modal>
</template>

<script>
import BsModal from './bs_modal'
import { ref } from 'vue'

export default {
  name: "update-acceptance",
  props: {
    acceptance: Number,
    value: Boolean,
    gridPoints: Array,
    lastPosition: Number,
    askForMediatorPerms: Boolean,
    issueid: Number,
    otherPartyEndedOrDoneSession: Boolean,
    sessionNumber: Number,
  },
  components: {
    BsModal,
  },
  emits: ['ok', 'cancel', 'update:acceptance', 'input'],
  setup(props, {emit}){
    const bsModal = ref(null)
    const endSession =  ref(true)
    const allowMediatorToSeeSecret = false

    const getAcceptance = (event) => {
      return parseFloat(event.target.value)
    }
    const handleOkClick = () => {
      emit('ok', {endSession: endSession.value, allowMediatorToSeeSecret: allowMediatorToSeeSecret})
      bsModal.value.modalHide()
    }
    const handleCancelClick = () => {
      emit('cancel')
      bsModal.value.modalHide()
    }

    return {
      bsModal,
      getAcceptance,
      handleOkClick,
      handleCancelClick,
      endSession,
      allowMediatorToSeeSecret
    }
  }
}
</script>
